import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import {
  faSearch,
  faEye,
  faInfoCircle,
  faBookmark,
  faUser,
  faTag,
  faChartLine,
  faSort,
} from '@fortawesome/free-solid-svg-icons';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import { faBuffer } from '@fortawesome/free-brands-svg-icons';
import { Chart } from 'angular-highcharts';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NftService } from '../../services/nft.service';
import { NftContractService } from '../../services/nft-contract.service';
import { MarketplaceService } from '../../services/marketplace.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { metamaskFactory } from '../../services/metamask.service';
import { environment } from 'src/environments/environment';
import { ScEventsService } from 'src/app/services/sc-events.service';
import Swal from 'sweetalert2';
import { ClaimContractService } from 'src/app/services/claim-contract.service';

// import {
//   PlainGalleryConfig,
//   Image,
//   PlainGalleryStrategy,
//   LineLayout
// } from '@ks89/angular-modal-gallery';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
})
export class DetailComponent implements OnInit {
  @Input() tab: 'lifeInfo' | 'stats' | 'land' | 'fusion' = 'lifeInfo';
  @ViewChild('approval', { static: false }) approvalModal: TemplateRef<void>;
  constructor(
    private modalService: NgbModal,
    private arouter: ActivatedRoute,
    private router: Router,
    private afs: AngularFirestore,
    private nftService: NftService,
    private nftContract: NftContractService,
    private market: MarketplaceService,
    private spinner: NgxSpinnerService,
    private contractEvent: ScEventsService,
    private activatedRoute: ActivatedRoute,
    private claimNftService: ClaimContractService
  ) {}

  specification;
  showToggle = {};

  faSearch = faSearch;
  faHeart = faHeart;
  faEye = faEye;
  faInfoCircle = faInfoCircle;
  faBookmark = faBookmark;
  faUser = faUser;
  faTag = faTag;
  faBuffer = faBuffer;
  faChartLine = faChartLine;
  faSort = faSort;
  nft;
  key;
  closeResult = '';
  time = { hour: 13, minute: 30 };
  spinners = false;

  selectExpire = [];
  selectedExpire = [];
  settingExpire = {};

  selectBlockchain = [];
  selectedBlockchain = [];
  settingBlockchain = {};

  nftList;
  tradingList;
  historyList;
  collection;
  storeAddress;
  sellAmountInvalid = false;
  sellAmountErrMsg;
  offerAmountInvalid = false;
  offerAmountErrMsg;
  makeOfferAmountInvalid = false;
  makeOfferAmountErrMsg;
  currentOffer = 0;
  currentOfferAddress;
  OfferStatus = false;
  sellPrice = 0.01;
  tokenAdd;
  blockchain;
  offChain;
  claimText = 'Retrieve coupon';
  claimStatus = false;
  signature;

  chart = new Chart({
    chart: {
      type: 'line',
    },
    title: {
      text: '',
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: 'Line 1',
        type: 'line',
        data: [1, 1.5, 1, 2],
        color: '#E6211A',
      },
    ],
  });

  ngOnInit(): void {
    this.storeAddress = localStorage.getItem('account_address');
    this.key = this.arouter.snapshot.params['key'];
    this.activatedRoute.queryParams.subscribe((params) => {
      this.tokenAdd = params['token_address'];
      this.blockchain = params['blockchain'];
      this.offChain = params['off_chain'];
    });

    // if (this.tokenAdd === '0xcea34fa634f6991dcf746047855d06b7326b979b') {
    //   this.getGameNftById();
    // } else {
    //   this.getAnimalNftById();
    // }

    this.nft = {
          "animal_attributes": [
            {"trait_type": "Gender", "value": "Male"},
            {"trait_type": "Eye Color", "value": "Blue"},
            {"trait_type": "Hair Color", "value": "Blue"},
            {"trait_type": "Hair Lenght", "value": "To Ears"},
            {"trait_type": "Age", "value": "17"},
            {"trait_type": "Move Speed", "value": "+10%"}
          ],
          "animal_description": "A super robot Eiji is a boy who used to be raised by his sister Ayaka, who he is searching for. He has a short temper and is either annoyed by Toga or Luna.",
          "animal_name": "Eiji Shigure",
          "animal_type": 0,
          "blockchain": "sepolia",
          "contract_address": "0x4edd7580fa191c7f05a92c6f9f06b25dffcd0d6f",
          "created_at": "2022-07-08T06:51:17.254Z",
          "creator": "0xdc7856dd0d8527c12c3e725fb7d7ded235850d61",
          "extra_attributes": [
            {"trait_type": "Gender", "value": "Male"},
            {"trait_type": "Eye Color", "value": "Blue"},
            {"trait_type": "Hair Color", "value": "Blue"},
            {"trait_type": "Hair Lenght", "value": "To Ears"},
            {"trait_type": "Age", "value": "17"},
            {"trait_type": "Move Speed", "value": "+10%"}
          ],
          "favourite": [],
          "file_type": "png",
          "isListed": true,
          "media_uri": "https://blush-biological-mink-848.mypinata.cloud/ipfs/QmeCtc7vf6Pm4gkqNRFhqtrCWXYyCtLNq9e7qcHkEohEGS/1.png",
          "metadata_uri": "https://blush-biological-mink-848.mypinata.cloud/ipfs/QmZnjpzPcYxmpTmnmfz3xskpMyz5uDgiWtu99DVGxnFcvB/1.json",
          "owner": "0x6cdd954d18287388a647bd76aea7f9c2b21b07e5",
          "owner_address": "0x6cdd954d18287388a647bd76aea7f9c2b21b07e5",
          "royalty": 10,
          "price": 0,
          "tokenId": 1,
          "token_address": "0x4edd7580fa191c7f05a92c6f9f06b25dffcd0d6f",
          "updated_at": "2023-04-06T17:01:04.874Z"
        }
    // this.addViewer();
    // this.contractEvent.startListener();
  }

  getAnimalNftById() {
    this.nftService.getAnimalNftByTokenId(this.key).subscribe((data) => {
      this.nft = data.result;
      console.log('nft', this.nft);

      if (this.nft.contract_address) {
        this.sellPrice = this.nft.price;
        this.getCurrentOfferByTokenId(
          this.key,
          this.nft.contract_address,
          this.nft.blockchain
        );
      } else {
        this.getGameNftById();
      }
    });
  }

  getGameNftById() {
    console.log(this.key, this.tokenAdd, this.blockchain);
    this.nftService
      .getGameNftByTokenId(this.key, this.tokenAdd, this.blockchain)
      .subscribe((data) => {
        this.nft = data.result;
        console.log('nft', this.nft);
        this.sellPrice = this.nft.price;

        this.getCurrentOfferByTokenId(
          this.key,
          this.nft.token_address,
          this.nft.blockchain
        );
      });
  }

  getCurrentOfferByTokenId(tokenId, contract_address, blockchain) {
    this.nftService
      .getCurrentOffer(tokenId, contract_address, blockchain)
      .subscribe((data) => {
        console.log('history', data);
        if (data.success) {
          this.currentOffer = data.result.amount;
          this.currentOfferAddress = data.result.current_offer;
          this.OfferStatus = true;
        }
      });
  }

  toggleTag(key) {
    this.showToggle[key] = !this.showToggle[key];
  }

  showQuickview(content) {
    this.modalService.open(content, { size: 'xl', centered: true });
  }

  productDetail() {
    this.router.navigate(['product/detail']);
  }

  open(content, type) {
    if (
      content._declarationTContainer.localNames[0] === 'toSell' ||
      content._declarationTContainer.localNames[0] === 'toOffer'
    ) {
      this.modalService.dismissAll('toMarket');
    }
    this.modalService.open(content, { size: type, centered: true });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  async setApproval() {
    var tokenAddress;
    if (this.nft.contract_address) {
      tokenAddress = this.nft.contract_address;
    }
    if (this.nft.token_address) {
      tokenAddress = this.nft.token_address;
    }

    try {
      this.spinner.show();
      const result = await this.nftContract.setApproveAll(tokenAddress, true);
      console.log('approval', result);
      if (result.status === true) {
        this.spinner.hide();
        this.modalService.dismissAll('approval');
        Swal.fire({
          title: 'Success!',
          text: 'Successfully approved.',
          icon: 'success',
        });
      }
    } catch (err) {
      console.log(err);
      this.spinner.hide();
      this.modalService.dismissAll('approval');
    }
  }

  async sellToMarket(sellPrice) {
    this.checkMetamask();
    if (sellPrice < 0.01) {
      this.sellAmountInvalid = true;
      this.sellAmountErrMsg = 'Amount is required and minimum amount is 0.01';
    } else {
      this.sellAmountInvalid = false;
    }

    if (this.sellAmountInvalid === false) {
      try {
        this.spinner.show();
        var tokenAddress;
        if (this.nft.contract_address) {
          tokenAddress = this.nft.contract_address;
        }
        if (this.nft.token_address) {
          tokenAddress = this.nft.token_address;
        }
        const data = await this.market.setTokenPrice(
          tokenAddress,
          this.nft.tokenId,
          sellPrice
        );
        if (data.timestamp > 0) {
          if (this.tokenAdd === '0xcea34fa634f6991dcf746047855d06b7326b979b') {
            this.getGameNftById();
          } else {
            this.getAnimalNftById();
          }
          this.modalService.dismissAll('sell');
          this.spinner.hide();
          if (this.nft.price == 0) {
            Swal.fire({
              title: 'Success!',
              text: 'You have listed your NFT!',
              icon: 'success',
            });
          } else {
            Swal.fire({
              title: 'Success!',
              text: 'You edited your price!',
              icon: 'success',
            });
          }

          console.log('result set price', data);
        }
      } catch (error) {
        console.log('err', error);
        this.spinner.hide();
        if (error.data.message.includes('Require owner approval')) {
          this.modalService.dismissAll('sell');
          this.modalService.open(this.approvalModal);
        } else {
          Swal.fire({
            title: 'Ooops...',
            text: 'Something is wrong. Please try again later.',
            icon: 'error',
          });
        }
      }
    }
  }

  async buyNft() {
    await this.checkMetamask();
    console.log('99', this.storeAddress);
    if (this.storeAddress !== 'undefined' && this.storeAddress !== null) {
      //start loading
      this.spinner.show();
      try {
        var tokenAddress;
        if (this.nft.contract_address) {
          tokenAddress = this.nft.contract_address;
        }
        if (this.nft.token_address) {
          tokenAddress = this.nft.token_address;
        }
        const data = await this.market.purchase(tokenAddress, this.nft.tokenId);
        if (data.timestamp > 0) {
          this.modalService.dismissAll('buy');
          if (this.tokenAdd === '0xcea34fa634f6991dcf746047855d06b7326b979b') {
            this.getGameNftById();
          } else {
            this.getAnimalNftById();
          }
          //end loading
          this.spinner.hide();
          Swal.fire({
            title: 'Success!',
            text: "It's yours now!",
            icon: 'success',
          });
        }
      } catch (err) {
        console.log(err.message);
        if (err.message.includes('unknown account #0')) {
          await this.checkMetamask();
        }
        this.spinner.hide();
        this.modalService.dismissAll('buy');
        Swal.fire({
          title: 'Ooops...',
          text: 'Something is wrong. Please try again later.',
          icon: 'error',
        });
      }
    }
    // else {
    //   this.router.navigate(['login']);
    //   this.modalService.dismissAll();
    // }
  }

  changeListStatus(tokenAdd, status) {
    this.spinner.show();
    if (tokenAdd === '0x4edd7580fa191c7f05a92c6f9f06b25dffcd0d6f') {
      //animal
      var param = {
        isListed: !status,
      };

      this.nftService
        .updateAnimalSale(param, this.nft.tokenId, this.nft.blockchain)
        .subscribe((data) => {
          if (data.result) {
            if (status) {
              Swal.fire({
                title: 'Success!',
                text: 'This NFT is delisted.',
                icon: 'success',
              });
            } else {
              Swal.fire({
                title: 'Success!',
                text: 'This NFT is listed.',
                icon: 'success',
              });
            }
            this.getAnimalNftById();
            this.spinner.hide();
            this.modalService.dismissAll('delisted');
          }
        });
    } else if (tokenAdd === '0xcea34fa634f6991dcf746047855d06b7326b979b') {
      //game
      var param = {
        isListed: !status,
      };
      this.nftService
        .updateGameSale(param, this.nft.tokenId, tokenAdd, this.nft.blockchain)
        .subscribe((data) => {
          if (data.result) {
            if (status) {
              Swal.fire({
                title: 'Success!',
                text: 'This NFT is delisted.',
                icon: 'success',
              });
            } else {
              Swal.fire({
                title: 'Success!',
                text: 'This NFT is listed.',
                icon: 'success',
              });
            }
            this.getGameNftById();
            this.spinner.hide();
            this.modalService.dismissAll('delisted');
          }
        });
    }
  }

  async onMakeOffer(amount) {
    await this.checkMetamask();

    if (amount === undefined) {
      this.makeOfferAmountInvalid = true;
      this.makeOfferAmountErrMsg = 'Amount is required';
      return;
    } else if (!this.OfferStatus && amount <= this.sellPrice) {
      this.makeOfferAmountInvalid = true;
      this.makeOfferAmountErrMsg =
        'The offer amount is need bigger than the selling amount. <br> Current price is ' +
        this.sellPrice +
        '.';
      return;
    } else if (!this.OfferStatus && amount < 0.01) {
      this.makeOfferAmountInvalid = true;
      this.makeOfferAmountErrMsg = 'The minimum offer amount is 0.01 ';
      return;
    } else if (this.OfferStatus === true && amount < this.currentOffer * 1.1) {
      this.makeOfferAmountInvalid = true;
      this.makeOfferAmountErrMsg =
        'The minimum bid offer amount at least increase 10% ';
      return;
    }
    //start loading
    this.spinner.show();
    try {
      var tokenAddress;
      if (this.nft.contract_address) {
        tokenAddress = this.nft.contract_address;
      }
      if (this.nft.token_address) {
        tokenAddress = this.nft.token_address;
      }
      const data = await this.market.makeOffer(
        tokenAddress,
        this.nft.tokenId,
        amount
      );

      if (data.timestamp > 0) {
        if (this.tokenAdd === '0xcea34fa634f6991dcf746047855d06b7326b979b') {
          this.getGameNftById();
        } else {
          this.getAnimalNftById();
        }
        this.modalService.dismissAll('offer');
        this.spinner.hide();
        Swal.fire({
          title: 'Success!',
          text: 'You made an offer.',
          icon: 'success',
        });
      }
    } catch (err) {
      console.log(err);
      this.spinner.hide();
      this.modalService.dismissAll('offer');
      Swal.fire({
        title: 'Ooops...',
        text: 'Something is wrong. Please try again later.',
        icon: 'error',
      });
    }
    this.makeOfferAmountErrMsg = '';
    this.makeOfferAmountInvalid = false;
  }

  getTradingHistoryByTokenId(tokenId) {
    var data = {
      tokenId: tokenId,
    };
    try {
      this.nftService.tradingHIstoryByTokenId(data).subscribe((data) => {
        this.tradingList = data.result;
      });
    } catch (err) {
      console.log(err);
    }
  }

  async onAcceptOffer() {
    await this.checkMetamask();
    //start loading
    this.spinner.show();
    try {
      const data = await this.market.acceptOffer(
        this.nft.token_address,
        this.nft.tokenId
      );
      if (data.timestamp > 0) {
        this.modalService.dismissAll('acceptOffer');
        if (this.tokenAdd === '0xcea34fa634f6991dcf746047855d06b7326b979b') {
          this.getGameNftById();
        } else {
          this.getAnimalNftById();
        }
        //end loading
        this.spinner.hide();
        Swal.fire({
          title: 'Success!',
          text: 'You accepted the offer!',
          icon: 'success',
        });
      }
    } catch (err) {
      console.log(err);
      this.spinner.hide();
      this.modalService.dismissAll('acceptOffer');
      Swal.fire({
        title: 'Ooops...',
        text: 'Something is wrong. Please try again later.',
        icon: 'error',
      });
    }
  }

  onClaimCoupon() {
    this.spinner.show();
    var body = {
      address: this.storeAddress,
      tokenId: Number(this.nft.tokenId),
      token_address: this.tokenAdd,
      blockchain: this.blockchain,
    };
    try {
      this.nftService.claimNFT(body).subscribe((data) => {
        console.log(data);

        if (data.success) {
          this.signature = data.result.signature;

          //end loading
          this.spinner.hide();
          this.claimText = 'Coupon Ready';
          this.claimStatus = true;
        } else {
          this.spinner.hide();
          Swal.fire({
            title: 'Warning',
            text: 'NFT must reach level 3 and above for user to mint',
            icon: 'warning',
          });
        }
      });
    } catch (err) {
      this.spinner.hide();
      this.modalService.dismissAll('claim');
      Swal.fire({
        title: 'Ooops...',
        text: 'Something is wrong. Please try again later.',
        icon: 'error',
      });
    }
  }

  onClaimNft() {
    try {
      if (this.claimStatus === true) {
        this.spinner.show();
        var body = {
          address: this.storeAddress,
          tokenId: Number(this.nft.tokenId),
          token_address: this.tokenAdd,
          blockchain: this.blockchain,
        };
        this.claimNftService
          .claimEquipmentNft(
            [this.nft.owner_address, body.address, body.tokenId],
            this.signature.r,
            this.signature.s,
            this.signature.v
          )
          .then((res) => {
            Swal.fire({
              title: 'Success!',
              text: 'You have minted your NFT!',
              icon: 'success',
            });

            //after call claim nft api success reset status
            this.spinner.hide();
            this.modalService.dismissAll('claim');
            this.claimStatus = false;
            this.claimText = 'Retrieve coupon';
            if (
              this.tokenAdd === '0xcea34fa634f6991dcf746047855d06b7326b979b'
            ) {
              this.getGameNftById();
            } else {
              this.getAnimalNftById();
            }
          });
      }
    } catch (err) {
      this.spinner.hide();
      this.modalService.dismissAll('claim');
      Swal.fire({
        title: 'Ooops...',
        text: 'Something is wrong. Please try again later.',
        icon: 'error',
      });
    }
  }

  checkMetamask() {
    metamaskFactory
      .getMetamaskService()
      .then(async (metamask) => {
        const account = await metamask.getCurrentAccount();
        localStorage.setItem('account_address', account);

        if (account === undefined) {
          this.router.navigate(['login']);
          this.modalService.dismissAll();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  back() {
    this.router.navigate(['product']);
  }
}
